import React, { useEffect } from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { observer } from 'mobx-react'
import VariationsHeightHeading from 'app/React/ProductForm/VariationsHeightHeading'
import Variations from 'app/React/ProductForm/Variations'
import {filter, sortBy} from 'remeda'
import { pipe } from 'ts-pipe-compose'

function normalizeHeight (height) {
  if (height.length === 6) {
    let min = Number(height.substr(0, 3))
    let max = Number(height.substr(3, 3))
    return (min + max) / 2
  } else {
    return Number(height)
  }
}
function VariationPicker(props){
  const [variations] = useEnvValue('variations',[])
  const [selectedVariation,setSelectedVariation] = useEnvValue('selectedVariation',null)
  const [selectedType] = useEnvValue('selectedType', null)

  useEffect(() => {
    if (selectedVariation?.type !== selectedType) {
      const _sortBy = (v) => selectedVariation !== null ? Math.abs(normalizeHeight(v.height) - normalizeHeight(selectedVariation.height)) : ''
      const closestVariation = pipe(
        variations,
        filter(v => v.type === selectedType),
        filter(v => v.stock),
        sortBy(v => _sortBy(v))
      )
      setSelectedVariation(closestVariation[0])
    }
  }, [selectedType, selectedVariation, variations])
  const selectedVariationId = function(){
    let input = jQuery('[name=prima_variation]:checked')
    if(input.length === 0) return ''
    return parseInt(input.val())
  }
  const getVariationById = function(id){
    let vl = variations.length
    if(vl === 0) return null
    for (let i = 0; i < vl; i++) {
      if(variations[i].id === id) return variations[i]
    }
    return null
  }
  const updateSelectedVariationInEnv = function(){
    let variation = getVariationById(selectedVariationId())
    setSelectedVariation(variation)
  }
  const onChange = function(){
    updateSelectedVariationInEnv()
  }

   return (
    <section className="mtt-variations" data-attribute="hoejde">
      <VariationsHeightHeading/>
      <Variations onChange={onChange}/>
    </section>
  )
}
export default observer(VariationPicker)